//import { testIds } from "../../../constants/testId";
//import Header from '../../molecules/Header/Header';
import styles from './companyProfile.module.scss';
import Tabs from '../../molecules/Tabs/tabs';
import tabConfig from './tab.config.js';
import { testIds } from '../../../constants/testId';
import { getDashboardData } from '../../../api/DashboardAPI';
import { useEffect, useState } from 'react';
import { getCurrentTaskConfig } from './taskHelpers';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchCompanyData } from './fetchCompanyData';
import { useNavigate } from 'react-router-dom';
import { getFromSessionStorage } from '../../common/Utility/Utility';
import ModalBox from '../../molecules/Modal/Modal.jsx';
import { getVendorDetailsV2 } from '../../../api/FetchCompanyProfile/index.js';
import Button from '../../atoms/Button/Button.jsx';
import { setProfileDetails, setUserPartnershiDetails } from '../../../redux/actions/actions.js';
import store from '../../../redux/store.js';
import ButtonComponent from '../../atoms/Button/Button.jsx';
import { PATHS } from '../../../constants/paths.js';

const CompanyProfile = ({ companyProfileState, setUserPartnershipDetails }) => {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(null);
  const [tabsConfigProcessed, setTabsConfigProcessed] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [accountDetails, setAccountDetails] = useState([]);
  const [currentTab, setCurrentTab] = useState();
  const [selectedAccountIndex, setSelectedAccountIndex] = useState();
  const [enableContBtn, setEnableContBtn] = useState(false);
  let { id } = JSON.parse(getFromSessionStorage('selectedPartnership')) || {};

  const fetchTasksData = async () => {
    try {
      let selectedPartnership = JSON.parse(getFromSessionStorage('selectedPartnership')) || {};
      if (!selectedPartnership || !selectedPartnership.id) {
        navigate(-1);
      }
      const dashboardData = await getDashboardData({
        'partnership-id': selectedPartnership.id
      });
      const { userPartnershipTaskResponse } = dashboardData;
      setUserPartnershipDetails(dashboardData);

      if (userPartnershipTaskResponse && userPartnershipTaskResponse.tasks) {
        setTasks(userPartnershipTaskResponse.tasks);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const selectedAccount =
    selectedAccountIndex !== undefined && selectedAccountIndex !== null
      ? accountDetails[selectedAccountIndex]
      : null;
  const isSubmitDisabled = !selectedAccount || selectedAccount.disabled;

  const handleSubmit = () => {
    const { dispatch } = store;
    const account = accountDetails[selectedAccountIndex];
    const newAccountDetails = { ...companyProfileState };
    newAccountDetails['bankDetails'] = [
      {
        accountNumber: account['accountNumber'],
        ifscCode: account['IFSCCode'],
        bankName: account['bankName'],
        beneficiaryName: newAccountDetails['tradeName']
      }
    ];
    dispatch(setProfileDetails(newAccountDetails));
    setModalOpen(false);
  };

  useEffect(() => {
    fetchTasksData();
    fetchCompanyData();
  }, []);

  useEffect(async () => {
    if (currentTab === 'bank' && companyProfileState && companyProfileState.id && !companyProfileState.bankDetails) {
      const params = {
        companyId: companyProfileState.id,
        eftEnabled: false
      };
      const response = await getVendorDetailsV2(params);
      if (response?.length) {
          setAccountDetails(response);
          setModalOpen(true);
      }
    }
  }, [currentTab, companyProfileState]);

  useEffect(() => {
    let tasksConfiguration = getCurrentTaskConfig(tasks, [...tabConfig]);
    setTabsConfigProcessed(tasksConfiguration);
    let tasksCompleted = tasks?.every((item) => item.status === 'COMPLETED');
    tasksCompleted && setEnableContBtn(tasksCompleted);
    if (tasksCompleted && id === "3") navigate(PATHS.commonTasks + `?id=${id}`)
  }, [tasks]);

  return (
    <div className={styles.container} data-testid={testIds['company-profile']}>
      <div className={styles['headInfo']}>
        <p>COMPANY PROFILE</p>
      </div>
      {tabsConfigProcessed && tabsConfigProcessed.length > 0 && (
        <Tabs info={tabsConfigProcessed} setCurrentTab={setCurrentTab} />
      )}
      <ModalBox
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        titleName="Choose Existing ERP Bank Account Details"
        className={styles.getInTouchModal}>
        <div className={styles['exiting-bank-details']}>
          {accountDetails.map((item, index) => (
            <label
              key={index}
              className={`${styles['account-option']} ${
                selectedAccountIndex === index ? styles['active'] : ''
              } ${item.disabled ? styles['disabled'] : ''}`}>
              <input
                type="radio"
                name="erp-bank-account"
                value={index}
                checked={selectedAccountIndex === index}
                disabled={item.disabled}
                onChange={() => setSelectedAccountIndex(index)}
                className={styles['account-radio']}
              />
              <div className={styles['account-info']}>
                <p>Account No: {item.accountNumber}</p>
                <p>Bank Name: {item.bankName}</p>
                <p>IFSC Code: {item.IFSCCode}</p>
              </div>
            </label>
          ))}
        </div>
        <div className={styles['modal-footer']}>
          <Button
            variant="primary-black"
            btnText="Cancel"
            onClick={() => setModalOpen(false)}></Button>
          <Button
            variant="primary"
            btnText="Submit"
            disabled={isSubmitDisabled}
            onClick={() => handleSubmit()}></Button>
        </div>
      </ModalBox>
      {enableContBtn && (
        <ButtonComponent
          onClick={() => navigate(PATHS.dashboard + `?id=${id}`)}
          className={styles.btn}
          variant="primary"
          btnText="Continue"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  companyProfileState: state.companyProfileState,
  selectedPartnership: state.selectedPartnershipReducer
});

const mapDispatchToProps = (dispatch) => ({
  setUserPartnershipDetails: (data) => dispatch(setUserPartnershiDetails(data))
});

CompanyProfile.propTypes = {
  companyProfileState: PropTypes.object,
  selectedPartnership: PropTypes.object,
  setUserPartnershipDetails: PropTypes.func
};
export default connect(mapStateToProps, mapDispatchToProps)(CompanyProfile);
